export const defaultPageSize = 24;

export const defaultPaginationParams = {
  page: 0,
  pageSize: defaultPageSize,
} as const;
